import { Dialog } from "@material-ui/core";
import "./dialog.scss"
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import Select from 'react-select'
import { useState } from "react";
import axios from "axios";
import httpService from "../../../../setup/http/httpServices";
import { useHistory } from "react-router-dom";
const baseURL = process.env.REACT_APP_API_URL;

interface ScreenCategory {
    id: number;
    name: string;
}


interface CreateFlowProps {
    open: boolean;
    onClose: () => void;
    selectedScreen?: any[];
    flowCategory?: any[];
    resetSelectedScreen?: () => void;
}


const CreateFlowDialog = ({ open, onClose, selectedScreen, flowCategory, resetSelectedScreen }: CreateFlowProps) => {
    const history: any = useHistory()
    const [flowOption, setFlowOption] = useState(null);


    // const selectedFlowCategory: string[] = flowOption.map((item: any) => item.value);

    // console.log('flowCategory', flowCategory)
    // console.log('flowOption', flowOption)
    // console.log('selectedScreen', selectedScreen)

    const handleChange = (selectedOption: any) => {
        setFlowOption(selectedOption);
    };

    // ADD FLOW HANDLER
    const addFlowHandler = () => {
        const app_id = history.location.state?.edit ? history.location.state?.appListing?._id : history.location.state?.app_id;
        axios.post(
            `${baseURL}/flow/add`,
            {
                headers: httpService.serviceHeader,
                screen_selected: selectedScreen,
                category_id: flowOption?.value,
                app_id: app_id,

            }
        ).then((res) => {
            console.log('flow:', res.data);
            onClose();
            setFlowOption(null);
            resetSelectedScreen();

        }).catch((error) => {
            console.error('Error:', error);
        });
    };



    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="sm" className="create-flow-dialog">
                <div className="create-flow-box">
                    <div className="flow-header">
                        <h1>Create Flow</h1>
                        <div className="close-icon" onClick={onClose}>
                            <img
                                style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
                                src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
                                alt='icon'
                            />
                        </div>
                    </div>
                    <h3>{selectedScreen?.length} Screens selected</h3>
                    <div className="row">
                        <div className='col '>
                            <h6 className='fw-bold required'>Select Flow Category</h6>
                            <Select
                                options={flowCategory?.map(category => ({ value: category._id, label: category.Name }))}
                                placeholder="Select Category ex. Authentication"
                                className="text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-1 categorySelect "
                                styles={{
                                    menuList: (provided, state) => ({
                                        ...provided,
                                        height: 'auto',
                                        maxHeight: '200px',
                                    }),
                                }}
                                value={flowOption}
                                onChange={handleChange}
                                isSearchable
                            // isMulti
                            />
                        </div>
                    </div>
                    <div className='d-flex pt-4 pe-5'>
                        <button
                            type='submit'
                            id='kt_sign_up_submit'
                            className='btn btn-primary  CompanyDetailButton'
                            onClick={addFlowHandler}
                        >
                            <span className='indicator-label'>Save Changes</span>

                        </button>

                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default CreateFlowDialog